import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import { styled } from '@mui/material/styles';

const MapContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    height: 200,
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    '& iframe': {
        width: '100%',
        height: '100%',
        border: 'none',
    },
}));

const GoogleMapEmbed = ({ 
    latitude, 
    longitude, 
    address,
    height = 200,
    showLink = true 
}) => {
    const getGoogleMapsUrl = () => {
        if (latitude && longitude) {
            // return `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=${latitude},${longitude}`;
            return`https://www.google.com/maps/embed/v1/view?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&center=${latitude},${longitude}&zoom=14`
        } else if (address) {
            const addressQuery = encodeURIComponent(address);
            return `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=${addressQuery}`;
        }
        return null;
    };

    const getGoogleMapsLinkUrl = () => {
        if (latitude && longitude) {
            return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
        } else if (address) {
            return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
        }
        return null;
    };

    const mapUrl = getGoogleMapsUrl();
    if (!mapUrl) return null;

    return (
        <>
            {showLink && (
                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PlaceIcon sx={{ color: 'primary.main', fontSize: '1.2rem' }} />
                    <Typography variant="subtitle2">
                        <Link 
                            href={getGoogleMapsLinkUrl()}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ textDecoration: 'none', color: 'primary.main' }}
                        >
                            Open in Google Maps
                        </Link>
                    </Typography>
                </Box>
            )}
            <MapContainer sx={{ height }}>
                <iframe
                    src={mapUrl}
                    loading="lazy"
                    title="Location Map"
                    allowFullScreen
                />
            </MapContainer>
        </>
    );
};

export default GoogleMapEmbed; 